import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Reportes } from '@pages/cobranza/interfaces/reportes';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class LibranzaReportsService {

  private _url = environment.apiBaseUrl + 'api/Reportes';

  constructor(private _http: HttpClient) { }

  getAllReports(model: Reportes): Observable<Reportes> {
    return this._http.post<Reportes>(this._url, model, httpOption);
  }
}